import { Outlet } from 'react-router-dom';

/**
 * AppShell — the persistent mobile layout wrapper for all protected /connect routes.
 *
 * Responsibilities:
 *   1. Renders <Outlet /> (the active route's page component)
 *
 * What AppShell does NOT do:
 *   - Inject a page header (each page renders its own <PageHeader> if needed)
 *   - Handle auth (PrivateRoute sits above AppShell in the router)
 *   - Manage page titles (pages set their own via <PageHeader title="..." />)
 *
 * Router wiring (router.js):
 *   { element: <PrivateRoute />, children: [{ element: <AppShell />, children: [...] }] }
 */
const AppShell = () => {
    return (
        <div className='w-full h-full'>
            <Outlet />
        </div>
    );
};

export default AppShell;
